import Meeting from './Meeting'

export default [
    {
        path: '/meeting/:patientId',
        props: true,
        component: Meeting
    }
]
